import {CustomError} from '../../../libs/shared/helpers/src/types/customErrors';
import {TagModel} from '../../models/api/tagModel';
import {ThunkAction} from '../../store/appThunk';
import {deleteTagConfirmedAction} from '../../store/data/tags/tagsActions';
import {deleteAsync} from '../http/http';
import {HttpResponseError} from '../http/httpError';
import {findTagQueue} from './specializedTaskQueues';

export class DeleteTagForbiddenError extends CustomError {}

export function deleteTagTask(tag: TagModel): ThunkAction {
  return async (dispatch, getState) => {
    // Find the tag to delete.
    const tagQueue = findTagQueue(dispatch, getState, tag.id);
    if (!tagQueue.get()) {
      throw new Error('A tag with this ID could not be found.');
    }

    // Note: We've explicitly chosen to *not* optimistically delete the tag here.

    // Wait for the queue to be available.
    await tagQueue.waitForTurnAsync();

    // Perform the request.
    try {
      await deleteAsync(tag.url);

      // Cleanup refrences to this tag.
      dispatch(deleteTagConfirmedAction(tag.id));

      // Report as deleted.
      tagQueue.reportDeleted();
    } catch (error) {
      tagQueue.reportError();

      if (!(error instanceof HttpResponseError)) {
        throw error;
      }

      switch (error.status) {
        case 403:
          throw new DeleteTagForbiddenError();
        default:
          throw error;
      }
    }
  };
}
